import * as React from "react";

export const IntegrationIcon = (props: { color: string }) => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8.76945 8.77C8.19945 9.34 8.19945 10.26 8.76945 10.82L6.64945 12.94L4.78945 11.08C4.21945 11.65 3.29945 11.65 2.73945 11.08C2.17945 10.51 2.16945 9.59 2.73945 9.03L0.749453 7.04L2.86945 4.92C3.43945 5.49 4.35945 5.49 4.91945 4.92C5.47945 4.35 5.48945 3.43 4.91945 2.87L7.03945 0.75L9.02945 2.74C9.59945 2.17 10.5195 2.17 11.0795 2.74C11.6395 3.31 11.6495 4.23 11.0795 4.79L12.9395 6.65L10.8195 8.77C10.2495 8.2 9.32945 8.2 8.76945 8.77Z"
                stroke={props.color}
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
        </svg>
    );
};
